import React, { useState } from "react";
import axios from "axios";
import ReCAPTCHA from "react-google-recaptcha";
import { BASE_URL } from "../../config";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

const SITE_KEY = "your-site-key-here";

const Contact = () => {
  const settings = useSelector((state) => state.settings);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [captchaToken, setCaptchaToken] = useState(null);
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState("");

  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required.";
    if (!formData.email.trim()) newErrors.email = "Email is required.";
    if (!formData.phone.trim()) newErrors.phone = "Phone Number is required.";
    if (!formData.message.trim()) newErrors.message = "Message is required.";
    if (!captchaToken) newErrors.captcha = "Please complete the CAPTCHA.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleCaptchaChange = (token) => {
    setCaptchaToken(token);
    setErrors({ ...errors, captcha: "" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setStatus("Sending...");

    try {
      console.log(`${BASE_URL}/contact`);
      const response = await axios.post(`${BASE_URL}/contact`, {
        ...formData,
        recaptcha_token: captchaToken,
      });

      if (response.data.success) {
        setStatus("Message sent successfully!");
        setFormData({ name: "", email: "", phone: "", message: "" });
        setCaptchaToken(null);
      } else {
        setStatus("Failed to send. CAPTCHA might be invalid.");
      }
    } catch (error) {
      setStatus("Submission failed.");
    }
  };

  return (
    <>
      <div className="tf-page-title style-2">
        <div className="container-full">
          <div className="heading text-center">Contact Us</div>
        </div>
      </div>
      <section className="flat-spacing-21">
        <div className="container">
          <div className="tf-grid-layout gap30 lg-col-2">
            <div className="tf-content-left">
              <h5 className="mb_20">Visit Our Store</h5>
              <div className="mb_20">
                <p className="mb_15">
                  <strong>Address</strong>
                </p>
                <p>{settings.address}</p>
              </div>
              <div className="mb_20">
                <p className="mb_15">
                  <strong>Phone</strong>
                </p>
                <p>{settings.phone}</p>
              </div>
              <div className="mb_20">
                <p className="mb_15">
                  <strong>Email</strong>
                </p>
                <p>{settings.email}</p>
              </div>
              <div>
                <ul className="tf-social-icon d-flex gap-20 style-default">
                  {settings.facebook ? (
                    <li>
                      <Link
                        to={settings.facebook}
                        target="_blank"
                        className="box-icon w_28 round social-facebook bg_line"
                      >
                        <i className="icon fs-14 icon-fb"></i>
                      </Link>
                    </li>
                  ) : (
                    ""
                  )}
                  {settings.twiter ? (
                    <li>
                      <Link
                        to={settings.twiter}
                        target="_blank"
                        className="box-icon w_28 round social-twiter bg_line"
                      >
                        <i className="icon fs-12 icon-twiter"></i>
                      </Link>
                    </li>
                  ) : (
                    ""
                  )}
                  {settings.instagram ? (
                    <li>
                      <Link
                        to={settings.instagram}
                        target="_blank"
                        className="box-icon w_28 round social-instagram bg_line"
                      >
                        <i className="icon fs-12 icon-instagram"></i>
                      </Link>
                    </li>
                  ) : (
                    ""
                  )}
                  {settings.snapchat ? (
                    <li>
                      <Link
                        to={settings.snapchat}
                        target="_blank"
                        className="box-icon w_28 round social-snapchat bg_line"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-snapchat"
                          viewBox="0 0 16 16"
                        >
                          <path d="M15.943 11.526c-.111-.303-.323-.465-.564-.599a1 1 0 0 0-.123-.064l-.219-.111c-.752-.399-1.339-.902-1.746-1.498a3.4 3.4 0 0 1-.3-.531c-.034-.1-.032-.156-.008-.207a.3.3 0 0 1 .097-.1c.129-.086.262-.173.352-.231.162-.104.289-.187.371-.245.309-.216.525-.446.66-.702a1.4 1.4 0 0 0 .069-1.16c-.205-.538-.713-.872-1.329-.872a1.8 1.8 0 0 0-.487.065c.006-.368-.002-.757-.035-1.139-.116-1.344-.587-2.048-1.077-2.61a4.3 4.3 0 0 0-1.095-.881C9.764.216 8.92 0 7.999 0s-1.76.216-2.505.641c-.412.232-.782.53-1.097.883-.49.562-.96 1.267-1.077 2.61-.033.382-.04.772-.036 1.138a1.8 1.8 0 0 0-.487-.065c-.615 0-1.124.335-1.328.873a1.4 1.4 0 0 0 .067 1.161c.136.256.352.486.66.701.082.058.21.14.371.246l.339.221a.4.4 0 0 1 .109.11c.026.053.027.11-.012.217a3.4 3.4 0 0 1-.295.52c-.398.583-.968 1.077-1.696 1.472-.385.204-.786.34-.955.8-.128.348-.044.743.28 1.075q.18.189.409.31a4.4 4.4 0 0 0 1 .4.7.7 0 0 1 .202.09c.118.104.102.26.259.488q.12.178.296.3c.33.229.701.243 1.095.258.355.014.758.03 1.217.18.19.064.389.186.618.328.55.338 1.305.802 2.566.802 1.262 0 2.02-.466 2.576-.806.227-.14.424-.26.609-.321.46-.152.863-.168 1.218-.181.393-.015.764-.03 1.095-.258a1.14 1.14 0 0 0 .336-.368c.114-.192.11-.327.217-.42a.6.6 0 0 1 .19-.087 4.5 4.5 0 0 0 1.014-.404c.16-.087.306-.2.429-.336l.004-.005c.304-.325.38-.709.256-1.047m-1.121.602c-.684.378-1.139.337-1.493.565-.3.193-.122.61-.34.76-.269.186-1.061-.012-2.085.326-.845.279-1.384 1.082-2.903 1.082s-2.045-.801-2.904-1.084c-1.022-.338-1.816-.14-2.084-.325-.218-.15-.041-.568-.341-.761-.354-.228-.809-.187-1.492-.563-.436-.24-.189-.39-.044-.46 2.478-1.199 2.873-3.05 2.89-3.188.022-.166.045-.297-.138-.466-.177-.164-.962-.65-1.18-.802-.36-.252-.52-.503-.402-.812.082-.214.281-.295.49-.295a1 1 0 0 1 .197.022c.396.086.78.285 1.002.338q.04.01.082.011c.118 0 .16-.06.152-.195-.026-.433-.087-1.277-.019-2.066.094-1.084.444-1.622.859-2.097.2-.229 1.137-1.22 2.93-1.22 1.792 0 2.732.987 2.931 1.215.416.475.766 1.013.859 2.098.068.788.009 1.632-.019 2.065-.01.142.034.195.152.195a.4.4 0 0 0 .082-.01c.222-.054.607-.253 1.002-.338a1 1 0 0 1 .197-.023c.21 0 .409.082.49.295.117.309-.04.56-.401.812-.218.152-1.003.638-1.18.802-.184.169-.16.3-.139.466.018.14.413 1.991 2.89 3.189.147.073.394.222-.041.464" />
                        </svg>
                      </Link>
                    </li>
                  ) : (
                    ""
                  )}
                  {settings.whatsapp_link ? (
                    <li>
                      <Link
                        to={settings.whatsapp_link}
                        target="_blank"
                        className="box-icon w_28 round social-whatsapp bg_line"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-whatsapp"
                          viewBox="0 0 16 16"
                        >
                          <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
                        </svg>
                      </Link>
                    </li>
                  ) : (
                    ""
                  )}
                </ul>
              </div>
            </div>
            <div className="tf-content-right">
              <h5 className="mb_20">Get In Touch</h5>
              <div>
                <form onSubmit={handleSubmit} className="form-contact">
                  <div className="d-flex gap-15 mb_15">
                    <fieldset className="w-100">
                      <input
                        type="text"
                        value={formData.name}
                        onChange={handleChange}
                        placeholder="Name *"
                      />
                      {errors.name && <p className="error">{errors.name}</p>}
                    </fieldset>
                  </div>
                  <div className="d-flex gap-15 mb_15">
                    <fieldset className="w-100">
                      <input
                        type="email"
                        value={formData.email}
                        onChange={handleChange}
                        placeholder="Email *"
                      />
                      {errors.name && <p className="error">{errors.email}</p>}
                    </fieldset>
                    <fieldset className="w-100">
                      <input
                        type="text"
                        value={formData.phone}
                        onChange={handleChange}
                        placeholder="Phone Number *"
                      />
                      {errors.name && <p className="error">{errors.phone}</p>}
                    </fieldset>
                  </div>
                  <div className="mb_15">
                    <textarea
                      placeholder="Message"
                      value={formData.message}
                      onChange={handleChange}
                      cols="30"
                      rows="10"
                    ></textarea>
                    {errors.name && <p className="error">{errors.message}</p>}
                  </div>
                  <ReCAPTCHA
                    sitekey={SITE_KEY}
                    onChange={handleCaptchaChange}
                  />
                  {errors.captcha && <p className="error">{errors.captcha}</p>}
                  <div className="send-wrap">
                    <button
                      type="submit"
                      className="tf-btn w-100 radius-3 btn-fill animate-hover-btn justify-content-center"
                    >
                      Submit
                    </button>
                    {status && <p className="mt-2">{status}</p>}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
